import { render, staticRenderFns } from "./TheWalletHeader.vue?vue&type=template&id=275317dc&scoped=true"
import script from "./TheWalletHeader.vue?vue&type=script&lang=js"
export * from "./TheWalletHeader.vue?vue&type=script&lang=js"
import style0 from "./TheWalletHeader.vue?vue&type=style&index=0&id=275317dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275317dc",
  null
  
)

export default component.exports